import { ConfigState } from 'store/config/types';
import { RootState } from 'store/reducer';
import { createSelector } from 'reselect';

export const configSelector = (state: RootState): ConfigState => state.config;

export const apiUrlSelector = createSelector(configSelector, (state: RootState['config']): string => state.apiUrl);
